export function ProblemSection() {
  return (
    <section className="relative py-28 px-6 lg:px-8">
      <div className="sc" aria-hidden="true">
        <svg width="2" height="24" viewBox="0 0 2 24">
          <line x1="1" y1="0" x2="1" y2="24" className="sc-line" stroke="#2563EB" strokeOpacity="0.3" strokeWidth="1.5" />
        </svg>
        <span className="sc-node" />
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16">
          <h2 className="text-[32px] sm:text-[40px] font-extrabold tracking-tight text-ink leading-[1.1]">
            Most teams discover their consent architecture is non-compliant the week before a regulator inquiry.
          </h2>
          <p className="mt-5 text-[16px] text-sub leading-relaxed">
            By then, five systems need to talk to each other, none of them do, and the audit trail is a spreadsheet.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {/* Card 1: Consent Storage */}
          <div className="card-lift bg-card border border-line rounded-xl2 p-6">
            <div className="w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center text-blue mb-5">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
              </svg>
            </div>
            <h3 className="font-semibold text-[14.5px] text-ink mb-2">Consent Storage</h3>
            <p className="text-[13px] text-sub leading-relaxed">
              Durable records of who consented, to what, under which notice version — queryable on demand.
            </p>
          </div>

          {/* Card 2: Notice Versioning */}
          <div className="card-lift bg-card border border-line rounded-xl2 p-6">
            <div className="w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center text-blue mb-5">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
            </div>
            <h3 className="font-semibold text-[14.5px] text-ink mb-2">Notice Versioning</h3>
            <p className="text-[13px] text-sub leading-relaxed">
              Every notice update tracked without breaking the integrity of past consent records.
            </p>
          </div>

          {/* Card 3: Audit Trails */}
          <div className="card-lift bg-card border border-line rounded-xl2 p-6">
            <div className="w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center text-blue mb-5">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="font-semibold text-[14.5px] text-ink mb-2">Audit Trails</h3>
            <p className="text-[13px] text-sub leading-relaxed">
              Immutable, timestamped event logs. Append-only at the database level.
            </p>
          </div>

          {/* Card 4: Data Principal Rights (Spans 2 columns) */}
          <div className="card-lift bg-card border border-blue/20 rounded-xl2 p-6 lg:col-span-2 bg-gradient-to-br from-card to-blue-50/50 dark:to-blue-950/20">
            <div className="w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center text-blue mb-5">
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </div>
            <h3 className="font-semibold text-[14.5px] text-ink mb-2">Data Principal Rights</h3>
            <p className="text-[13px] text-sub leading-relaxed mb-4">
              Under Sections 12–13 of the DPDP Act, every data principal has the right to access, correct, and withdraw consent. Failure to honour these requests is the most common source of regulatory action.
            </p>
            <span className="inline-flex items-center gap-1.5 text-[11.5px] font-medium text-blue">
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              Highest regulatory exposure
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
